"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureFlagUserIdentify = exports.featureFlagClientInit = exports.FeatureFlagUserBuilder = exports.resetCustomBuilderVariable = void 0;

var tslib_1 = require("tslib");

var launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");

var CUSTOM_BUILDER = false;

var resetCustomBuilderVariable = function resetCustomBuilderVariable() {
  return CUSTOM_BUILDER = false;
};

exports.resetCustomBuilderVariable = resetCustomBuilderVariable;
var DEFAULT_USER_KEY = "web-investor";
var PRIVATE_ATTRIBUTES = ["ip", "email", "name", "firstName", "lastName"];

var FeatureFlagUserContext =
/** @class */
function () {
  function FeatureFlagUserContext(key, anonymous) {
    this.kind = 'user';
    this.key = key;
    this.anonymous = anonymous;
  }

  return FeatureFlagUserContext;
}();

var FeatureFlagUser =
/** @class */
function (_super) {
  (0, tslib_1.__extends)(FeatureFlagUser, _super);

  function FeatureFlagUser(key, customAttributes, anonymous) {
    var _this = _super.call(this, key, anonymous) || this;

    _this.country = customAttributes.country;
    _this.investorType = customAttributes.investorType;
    _this.investorStatus = customAttributes.investorStatus;
    _this.distributor = customAttributes.distributor;
    _this.investorDomain = customAttributes.investorDomain;
    _this.investorRegion = customAttributes.investorRegion;
    _this.alphaInvestor = customAttributes.alphaInvestor;
    _this.betaInvestor = customAttributes.betaInvestor;
    _this.pensionsActive = customAttributes.pensionsActive;
    _this.investmentsActive = customAttributes.investmentsActive;
    _this.secondary = customAttributes.secondary;
    return _this;
  }

  return FeatureFlagUser;
}(FeatureFlagUserContext);

var FeatureFlagUserBuilder =
/** @class */
function () {
  function FeatureFlagUserBuilder(key, customAttributes) {
    if (customAttributes === void 0) {
      customAttributes = {};
    }

    this._user = new FeatureFlagUser(key || DEFAULT_USER_KEY, customAttributes);
  }

  FeatureFlagUserBuilder.prototype.secondary = function (secondary) {
    this._user.secondary = secondary;
    return this;
  };

  FeatureFlagUserBuilder.prototype.country = function (country) {
    this._user.country = country;
    return this;
  };

  FeatureFlagUserBuilder.prototype.anonymous = function (anonymous) {
    this._user.anonymous = anonymous;
    return this;
  };

  FeatureFlagUserBuilder.prototype.investorType = function (investorType) {
    this._user.investorType = investorType;
    return this;
  };

  FeatureFlagUserBuilder.prototype.investorStatus = function (investorStatus) {
    this._user.investorStatus = investorStatus;
    return this;
  };

  FeatureFlagUserBuilder.prototype.distributor = function (distributor) {
    this._user.distributor = distributor;
    return this;
  };

  FeatureFlagUserBuilder.prototype.investorDomain = function (investorDomain) {
    this._user.investorDomain = investorDomain;
    return this;
  };

  FeatureFlagUserBuilder.prototype.investorRegion = function (investorRegion) {
    this._user.investorRegion = investorRegion;
    return this;
  };

  FeatureFlagUserBuilder.prototype.alphaInvestor = function (alphaInvestor) {
    this._user.alphaInvestor = alphaInvestor;
    return this;
  };

  FeatureFlagUserBuilder.prototype.betaInvestor = function (betaInvestor) {
    this._user.betaInvestor = betaInvestor;
    return this;
  };

  FeatureFlagUserBuilder.prototype.pensionsActive = function (pensionsActive) {
    this._user.pensionsActive = pensionsActive;
    return this;
  };

  FeatureFlagUserBuilder.prototype.investmentsActive = function (investmentsActive) {
    this._user.investmentsActive = investmentsActive;
    return this;
  };

  FeatureFlagUserBuilder.prototype.build = function () {
    CUSTOM_BUILDER = true;
    return this._user;
  };

  return FeatureFlagUserBuilder;
}();

exports.FeatureFlagUserBuilder = FeatureFlagUserBuilder;

function featureFlagClientInit(clientSideID, userContext, options) {
  return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
    var ldOptions, client_1, err_1, message;
    return (0, tslib_1.__generator)(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!CUSTOM_BUILDER) return [3
          /*break*/
          , 4];
          ldOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, options), {
            privateAttributes: PRIVATE_ATTRIBUTES
          });
          client_1 = (0, launchdarkly_js_client_sdk_1.initialize)(clientSideID, userContext, ldOptions);
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , new Promise(function (resolve) {
            client_1.on("ready", function () {
              resolve(client_1);
            });
          })];

        case 2:
          return [2
          /*return*/
          , _a.sent()];

        case 3:
          err_1 = _a.sent();
          message = err_1.message;
          console.error(message);
          return [2
          /*return*/
          , undefined];

        case 4:
          console.error("Please use LDUserBuilder to set user attributes");
          return [2
          /*return*/
          , undefined];
      }
    });
  });
}

exports.featureFlagClientInit = featureFlagClientInit;

function featureFlagUserIdentify(client, ldUserContext, onDone) {
  return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
    return (0, tslib_1.__generator)(this, function (_a) {
      if (CUSTOM_BUILDER) {
        return [2
        /*return*/
        , client.identify(ldUserContext, undefined, onDone)];
      }

      console.error("Please use LDUserBuilder to set user attributes");
      return [2
      /*return*/
      , undefined];
    });
  });
}

exports.featureFlagUserIdentify = featureFlagUserIdentify;